function formatPrice(price) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price / 100);
}

function getUpsellContainer() {
  return document.getElementById('jump-upsell');
}

function getProdContainer(element) {
  const elem = element.closest('[data-proid]');

  if (elem !== null) {
    return elem;
  } else {
    console.error('Product container upsell not detected');
  }
}

function getInputElem(prodContainer) {
  const elem = prodContainer.querySelector('[data-line-id]');
  if (elem !== null) {
    return elem;
  } else {
    console.error('Product upsell quantity not detected');
  }
}

function dispatchInputEvent(produQuantityInput) {
  const event = new Event('changeInput');
  produQuantityInput.dispatchEvent(event);
}

function checkCart(cart) {
  if (cart.items.length === 0) {
    const upsellContainer = getUpsellContainer();
    upsellContainer.classList.add('tw-hidden');
  }
}

function textInputQuantityBehaviour(inputs) {
  inputs.forEach((input) => {
    input.addEventListener('changeInput', async () => {
      const prodContainer = getProdContainer(input);
      const prodId = prodContainer.dataset.proid;
      const prodValue = Number(input.value);

      const data = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: prodId,
          quantity: prodValue,
        }),
      })
        .then((response) => {
          if (prodValue === 0) {
            prodContainer.remove();
          }

          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      const prodPriceElem = prodContainer.querySelector('[data-product-price]');

      prodPriceElem.innerHTML = formatPrice(data.total_price);

      const event = new Event('updatedPrice');
      document.dispatchEvent(event);
      checkCart(data);
    });
  });
}

function quantityInputsBehaviour(minusButtons, plusButtons) {
  minusButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const prodContainer = getProdContainer(button);

      const produQuantityInput = getInputElem(prodContainer);

      produQuantityInput.value = Number(produQuantityInput.value) - 1;
      dispatchInputEvent(produQuantityInput);
    });
  });

  plusButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const prodContainer = getProdContainer(button);

      const produQuantityInput = getInputElem(prodContainer);

      produQuantityInput.value = Number(produQuantityInput.value) + 1;
      dispatchInputEvent(produQuantityInput);
    });
  });
}

function removeItemFromCart(removeUpsell) {
  removeUpsell.forEach((upsell) => {
    upsell.addEventListener('click', async () => {
      const prodContainer = getProdContainer(upsell);
      const prodId = prodContainer.dataset.proid;

      const data = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: prodId,
          quantity: 0,
        }),
      })
        .then((response) => {
          prodContainer.remove();

          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });

      checkCart(data);
    });
  });
}

function quantityArrowBehaviour() {
  const minusButtons = document.querySelectorAll('[data-icon=minus]');
  const plusButtons = document.querySelectorAll('[data-icon=plus]');
  const inputs = document.querySelectorAll('[data-line-id]');
  const removeUpsell = document.querySelectorAll('[data-remove-upsell]');

  quantityInputsBehaviour(minusButtons, plusButtons);

  textInputQuantityBehaviour(inputs);

  removeItemFromCart(removeUpsell);
}

function clickOnOverlay(upsellContainer) {
  const overlay = document.getElementById('overlay');

  overlay.addEventListener('click', () => {
    upsellContainer.classList.add('tw-hidden');
  });
}

function clickOnClose(upsellContainer) {
  const overlay = upsellContainer.querySelector('.common-close');
  const continueShoppingButton = upsellContainer.querySelector('.con-shopping');

  overlay.addEventListener('click', () => {
    upsellContainer.classList.add('tw-hidden');
  });
  continueShoppingButton.addEventListener('click', () => {
    upsellContainer.classList.add('tw-hidden');
  });
}

function clickToUpgrade(upsellContainer) {
  const upgradeButton = upsellContainer.querySelector('.upgrade-button');

  upgradeButton.addEventListener('click', async () => {
    const productToRemove = upsellContainer.dataset.productidremove;

    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: productToRemove,
        quantity: 0,
      }),
    }).catch((error) => {
      console.error('Error:', error);
    });

    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: upsellContainer.dataset.productidadd,
        quantity: 1,
      }),
    })
      .then(() => {
        upsellContainer.classList.add('tw-hidden');
        window.upcartOpenCart();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  });
}

async function populateCartItems(upsellContainer, data) {
  const { items, total_price } = await getCartInfo();

  if (items.length !== 0) {
    const cartItemsContainer = upsellContainer.querySelector('.cart-items-container .items-container');
    cartItemsContainer.innerHTML = '';
    items.forEach((item) => {
      const newDiv = document.createElement('div');

      const formattedPrice = formatPrice(item.final_line_price);

      newDiv.innerHTML = `
          <div
            class="tw-flex tw-text-left tw-items-center tw-mb-[5px]"
            data-proid="${item.variant_id}"
            data-count="${item.quantity}"
          >
            <div class="tw-w-20 lg:tw-w-[90px]">
              <a href="/products/${item.handle}">
                <img src="${item.image}" width="90" height="90">
              </a>
            </div>
            <div class="tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between lg:tw-items-baseline tw-items-start tw-pl-5 tw-w-[calc(100%-80px)]">
              <div class="titles">
                <div class="tw-text-xs lg:tw-text-base lg:tw-font-semibold text-[#1392c2]">${item.product_title}</div>
              </div>
              <div class="tw-order-3 lg:tw-order-1 tw-flex tw-flex-col tw-justify-center tw-items-center tw-max-w-[116px]">
                <label class="label is-sr-only tw-hidden" for="quantity">Qty</label>
                <div class="tw-flex">
                  <div class="tw-w-10 tw-h-[26px]">
                    <span
                      class="tw-border tw-border-[#CCCCCC] tw-block tw-w-full tw-rounded-tl-xl tw-rounded-bl-xl tw-cursor-pointer"
                      data-update-quantity="minus"
                    >
                      <span class="tw-w-6 tw-h-6 tw-p-1 tw-flex tw-justify-center tw-items-center" data-icon="minus">
                        <svg class="tw-w-[10px] tw-h-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                          <g id="minus"><rect x="5" y="46" width="90" height="8"></rect></g>
                        </svg></span
                    ></span>
                  </div>
                  <div class="tw-w-full">
                    <input
                      class="tw-h-[26px] tw-w-full tw-text-center tw-border-y tw-border-y-[#CCCCCC] input-field"
                      type="number"
                      min="1"
                      size="2"
                      name="quantity"
                      value="${item.quantity}"
                      data-line-id=""
                    >
                  </div>
                  <div class="tw-w-10 tw-h-[26px]">
                    <span
                      class="tw-border tw-border-[#CCCCCC] tw-block tw-w-full tw-rounded-tr-xl tw-rounded-br-xl tw-cursor-pointer"
                      data-update-quantity="plus"
                    >
                      <span class="tw-w-6 tw-h-6 tw-p-1 tw-flex tw-justify-center tw-items-center" data-icon="plus">
                        <svg class="tw-w-[10px] tw-h-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                          <g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g>
                        </svg></span
                    ></span>
                  </div>
                </div>
                <a href="#" data-remove-upsell="${item.variant_id}" class="tw-text-[10px] tw-text-black">Remove</a>
              </div>
              <div class="tw-order-1 lg:tw-order-3">
                <div data-product-price class="tw-text-[15px] lg:tw-text-lg tw-text-black">                  
                  ${formattedPrice}
                </div>
              </div>
            </div>
          </div>
        `;

      cartItemsContainer.appendChild(newDiv);
    });

    updateComponentsVisuals(total_price, upsellContainer);
    quantityArrowBehaviour();
    clickOnOverlay(upsellContainer);
    clickOnClose(upsellContainer);
    clickToUpgrade(upsellContainer);
  }
}

async function initBuyButtonLogic(upsellContainer) {
  upsellContainer.classList.remove('tw-hidden');
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');
  const quantity = document.querySelector('.pdp-quantity').value;

  const data = await fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId || upsellContainer.dataset.productidremove,
      quantity,
    }),
  })
    .then((resp) => resp.json())
    .catch((error) => {
      console.error('Error:', error);
    });

  await populateCartItems(upsellContainer, data);
}

function clickToShowUpsell(upsellContainer) {
  const addButton = document.querySelector('.add-button');
  const stickyAddButton = document.querySelector('.jump-sticky-cta-button');

  addButton.addEventListener('click', async () => {
    await initBuyButtonLogic(upsellContainer);
  });

  stickyAddButton.addEventListener('click', async () => {
    await initBuyButtonLogic(upsellContainer);
  });
}

async function getCartInfo() {
  return await fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((resp) => resp.json())
    .catch((error) => {
      console.error('Error:', error);
    });
}

function showUpsellInfo() {
  const upsellInfo = document.getElementById('upsellInfo');
  upsellInfo.classList.remove('tw-hidden');
}

function removeLoader(upsellContainer) {
  const loader = upsellContainer.querySelector('.ajax__loader');
  loader.classList.add('tw-hidden');
}

function updateTotalButton(total_price) {
  const subTotalSpan = document.getElementById('cartSubtotal');
  subTotalSpan.innerHTML = formatPrice(total_price);
}

function updateComponentsVisuals(total_price, upsellContainer) {
  updateTotalButton(total_price);

  removeLoader(upsellContainer);

  showUpsellInfo();
}

document.addEventListener('DOMContentLoaded', () => {
  const upsellContainer = getUpsellContainer();

  if (upsellContainer !== null && upsellContainer.dataset.hasupsell === 'true') {
    clickToShowUpsell(upsellContainer);
    window.upcartOpenOnAddToCartOverride = false;
  }
});

document.addEventListener('updatedPrice', async () => {
  const { total_price } = await getCartInfo();
  const upsellContainer = getUpsellContainer();

  updateTotalButton(total_price);
});
